export default {
    data() {
        return {
            isOtpApiCalled: false,
            otpSent: false, // Added variable to track OTP sent status
            isDisabled: true,
            resendOtp: false,
            timerRunning: false,
            minutes: 5,
            seconds: 0,
            passwordFieldType: 'password',
            confPasswordFieldType: 'password',
            init: false,
            loadingOtp: false,
            contIndex: 0,
            getOTPmsg:false,
            loginMethod: 'password',

        }
    },
    methods: {
        refreshData() {
            this.form = {
                code: this.$siteSettings.data && this.$siteSettings.data.cncode ? this.$siteSettings.data.cncode : "91",
                mobileNo: "",
                otp: '',
                userName: '',
                userId: '',
                password: "",
                confirmPassword: "",
                type: this.$siteSettings?.data?.business_type == 2 ? 1 : 2,
            },
                this.isRefral=false,
                this.isOtpApiCalled = false,
                this.resendOtp = false,
                this.resendOtpTimer = 0,
                this.timerRunning = false,
                this.minutes = 0,
                this.seconds = 0,
                this.otpSent = false,
                this.passwordFieldType = 'password',
                this.confPasswordFieldType = 'password',
                this.init = false,
                this.contIndex = 0;
                this.isSetUserId= false;
                this.isRefral= false
                this.hasUrlReferer= false,
                this.getOTPmsg= false,
                this.loginMethod= 'password',
                this.showValidationError = false;
                this.oldPassword = ''; 
                this.newPassword = '';
                this.confirmPassword = '';

        },
        sendOtpCall() {
            if (this.form.mobileNo && this.form.mobileNo?.length == 10) {
                this.sendOtpServiceCall();
            }
        },
        sendOtpServiceCall() {
            this.loadingOtp = true;
            this.$apiCall('post', 'SEND_OTP', { mobile_number: this.form.mobileNo, cncode: this.form.code }).then(response => {
                this.loadingOtp = false;
                if (response) {
                    if (response.status == 200) {
                        this.isOtpApiCalled = true;
                        this.otpSent = true; // OTP sent successfully, disable phone number field
                        this.isDisabled = false;
                        this.$successToast(response.data.message)
                        this.resendOtp = true;
                        this.timerRunning = true;
                        this.minutes = 5;
                        this.seconds = 0;
                        this.setResendTimer();
                        this.getOTPmsg = false;
                    }
                }
            }).catch(error => {
                this.getOTPmsg = false;
                this.loadingOtp = false;
                if (error)
                    this.$errorToast(error[0])
            });
        },
        getOtp() {
            return this.form.otp.toString();
        },
        togglePasswordVisibility(fieldName) {
            this[fieldName] = this[fieldName] === 'password' ? 'text' : 'password';
        },
        setResendTimer() {

            const countdown = () => {
                if (this.minutes === 0 && this.seconds === 0) {
                    this.timerRunning = false;
                    // Timer has expired, you can perform any action here
                } else {
                    if (this.seconds === 0) {
                        this.minutes--;
                        this.seconds = 59;
                    } else {
                        this.seconds--;
                    }
                    setTimeout(countdown, 1000);
                }
            };

            setTimeout(countdown, 1000);
        },
        formatTime(value) {
            return value < 10 ? `0${value}` : value;
        },
    }
}